import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  resultsContainer: {
    backgroundColor: theme.colorPalette.beige_25,
    boxShadow: '0px 20px 40px -10px rgba(0,0,0,0.5)'
  },
  tableRow: {
    height: 48,
    '& > td': {
      color: theme.colorPalette.green_90
    },
    '& > td:first-child': {
      paddingLeft: '2.5%'
    },
    '& > td:last-child': {
      paddingRight: '2.5%'
    }
  }
}));
